import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from 'rxjs/internal/Observable';
import { environment } from "src/environments/environment";
import { CanonicalService } from "../services/canonical.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";

@Injectable({
    providedIn: 'root',
  })
  export class IpoHomeResolver implements Resolve<Object> {
    constructor(
      private canonicalService: CanonicalService,
      @Inject(LOCALE_ID) private localId: Object,
      public jsonldService: JsonldService,
      private seoService:MetaSeoService,
    ){}

    resolve(route: ActivatedRouteSnapshot): Observable<Object> {
      const subSuffex = "/ipo-calendar"
      const domain = environment.domain;
      const lang = String(this.localId).substring(0, 2);
      let domainAndLangURL = `${domain}/${lang}`;
      let canonicalURL = domainAndLangURL+subSuffex;
      const year = new Date().getFullYear();
      let titlePrefix = `IPO Calendar`;
      let title = `${titlePrefix}  | Halka Arz Info`;
      let description = `Learn the dates of companies to be offered on the stock market with the IPO Calendar. Access the SPK-approved IPO list and detailed information on company offerings here.`;
      if(lang == "tr"){
        titlePrefix = `Halka Arz Takvimi`;
        title = `${titlePrefix}  | Halka Arz Info`;
        description = `Halka Arz Takvimi ile borsada satışa sunulacak şirketlerin tarihlerini öğrenin. SPK onaylı halka arz listesi ve şirketlerin halka arz detaylarına buradan ulaşın.`;
      }
      this.canonicalService.setCanonicalURLForId(canonicalURL);
      this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,"");
      this.canonicalService.setWrapperAlternate(domain,subSuffex);
      this.jsonldService.removeJsonSnippet();
      this.jsonldService.setOrganization();
      this.jsonldService.setBreadCrumbListItem(domain,lang,title,subSuffex)
      this.jsonldService.setWebSiteType(domain,lang);
      this.jsonldService.setTableType(titlePrefix);
      return null;
    }

}
